import { withAITracking } from "@microsoft/applicationinsights-react-js";
import React from "react";
import { Image } from "react-bootstrap";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import { reactPlugin } from "../../../utilities/AppInsights";
import "./SubmitLoanPage.css"
import FullLogo from '../../../assets/full_logo.png'
import { AppState } from "redux/store/store";
import { toggleAPIRequestSuccess, toggleLoading, getLoggedInAccountInfo } from "redux/actions/system/actions";
import Dealer from "models/dealerPurchase/dealer";
import { ConnectedProps, connect } from "react-redux";
import dealerService from "accessors/dealerService";
import LoadingSpinner from "shared/components/spinner/LoadingSpinner";
import ApplicantForm from "../../../components/loan/applicationForm/ApplicationForm";
import LoanApplication from "models/loan/loanApplication";
import loanApplicationService from "accessors/loanApplicationService";
import { withAuth0, WithAuth0Props } from "@auth0/auth0-react";


const mapState = (state: AppState, route: any) => {
  const { system } = state;
  const { isLoading, apiRequestSuccess, loggedInAccount } = system;
  return {
    isLoading,
    apiRequestSuccess,
    route,
    loggedInAccount,
  };
};

const mapDispatch = {
  toggleLoading: (isLoading: boolean) => toggleLoading(isLoading),
  toggleAPIRequestSuccess: (apiRequestSuccess: boolean) => toggleAPIRequestSuccess(apiRequestSuccess),
  getLoggedInAccountInfo,
}

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux & WithAuth0Props;

interface SubmitLoanPageState {
  dealers: Dealer[];
  draftTokens: string[];
}

class SubmitLoanPage extends React.Component<Props, SubmitLoanPageState> {
  constructor(props: any) {
    super(props);

    this.state = {
      dealers: [],
      draftTokens: []
    }
  }

  componentDidMount() {
    this.loadDealers();

    const oldToken = localStorage.getItem('agcredit_draft_token');
    if (oldToken) {
      localStorage.setItem('agcredit_draft_tokens', JSON.stringify([oldToken]));
      localStorage.removeItem('agcredit_draft_token');
    }
    const draftTokens = JSON.parse(localStorage.getItem('agcredit_draft_tokens') ?? '[]') as string[];
    this.setState({ draftTokens });
  }

  componentDidUpdate(prevProps: Readonly<Props>) {
    if (this.props.auth0.isAuthenticated && !this.props.auth0.isLoading && !prevProps.auth0.isAuthenticated) {
      this.props.getLoggedInAccountInfo();
    }
  }

  loadDealers() {
    this.props.toggleLoading(true);
    dealerService.GetDealersPublic()
      .then(dealers => {
        this.props.toggleLoading(false);
        this.setState({ dealers: dealers })
      })
  }

  async submitLoanApplication(loanApplication: LoanApplication): Promise<boolean> {
    this.props.toggleLoading(true);
    const loanId = await loanApplicationService.SubmitLoanApplication(loanApplication);
    this.props.toggleLoading(false);

    if (loanId > 0) {
      for (const token of this.state.draftTokens) {
        try {
          await loanApplicationService.DeleteDraftPublic(token);
        } catch {
          // Silent fail — draft expires in 30 days; don't block redirect
        }
      }
      localStorage.removeItem('agcredit_draft_tokens');
      this.props.route.history.push(`/thank-you/${loanId}`);
    }
    return loanId > 0;
  }

  render() {
    const customerAccountInfo = Object.keys(this.props.loggedInAccount).length > 0 ? this.props.loggedInAccount : undefined;

    return (
      <div className="container">
        <Container fluid className="align-items-center px-4">
          <Row className="justify-content-md-center">
            <div style={{ textAlign: 'center' }}>
              <Image src={FullLogo} width="50%" />
            </div>
            <ApplicantForm
              dealers={this.state.dealers}
              userLoggedIn={customerAccountInfo != undefined}
              customerAccountInfo={customerAccountInfo}
              toggleLoading={this.props.toggleLoading}
              submitCallback={this.submitLoanApplication.bind(this)}
              initialDraftToken={this.state.draftTokens[0]}
            ></ApplicantForm>
          </Row>
        </Container>
        {this.props.isLoading &&
          <LoadingSpinner
            variant={'dark'}
            animation={'border'}
          />
        }
      </div>
    );
  }
}

export default withAITracking(reactPlugin, connector(withAuth0(SubmitLoanPage)));
